export default __webpack_public_path__ + "static/media/verified.037bbec8.png";